<template lang="pug">
  PrintablePanel
    SplitByIdModal(
      :show="showModal"
      :id-key="idKey"
      :bio-key="bioKey"
      :possible-id-keys="possibleIdKeys"
      @closeDetail="showModal = false, idKey = '', bioKey = '', possibleIdKeys = []"
    )
    PageHeader Split by Id
    .row.split-ids(v-if="columnHeaders")
      .col
        Datatable.mt-3(
          :columns="columnHeaders"
          :entries="[0]"
          tableKey="splitByIdTable"
          :per-page="15"
          :footer="true"
          :header-style="{fontSize: '0.75rem'}")
          template(v-for="counts, index in entries.data")
            tr 
              td {{ splitByIdColumns(index, entries) }}
              td(v-for="count, count_index in counts")
                div(id="split-count" @click="showModal = true, idKey = retrieveIdKey(index), bioKey = retrieveBioKey(count_index), possibleIdKeys = retrievePossibleIdKeys()") {{ count }}
            tr

</template>

<script>
import Datatable from '../components/Datatable'
import HelpPopover from '../components/HelpPopover'
import CustomCheckbox from '@/components/CustomCheckbox'
import CustomRadio from '@/components/CustomRadio'
import SplitByIdModal from '@/components/SplitByIdModal'
import Modal from '@/components/Modal'
import PageHeader from '@/components/PageHeader'
import Datepicker from '@/components/Datepicker'
import PrintablePanel from '@/components/PrintablePanel'
import axios from '@/lib/axios'
import router from '@/router'
import { format, parse, addDays } from 'date-fns/esm'
import { globalError, globalSuccess, idType, waitReport } from '@/lib/utils'
import { formItem, clearForm } from '@/lib/formstore'

export default {
  name: 'SplitById',
  data: function() {
    return {
      entries: [],
      headers: [],
      idKey: "",
      bioKey: "",
      possibleIdKeys: [],
      showModal: false,
    }
  },
  computed: {
    columnHeaders() {
      let headersArray = [];
      headersArray = this.headers.map(function (r) {
        return ('<div>' + r.lastName + '</div>' + '<div>' +r.birthDt + '</div>' + '<div>' +r.postalCode + '</div>')
      })
      headersArray.unshift("");
      return headersArray;
    },
  },
  methods: {
    getData() {
      return entries;
    },
    splitByIdColumns(index, entries) {
      let headers = this.entries.idHeader;
      let combinedHeader = headers[index]['idNbr'] + " " + headers[index]['idStateCd'] + " " + headers[index]['idTypeCd']

      return combinedHeader;
    },
    retrieveIdKey(index,) {
      return ([this.entries.idHeader[index].idNbr.toString(), this.entries.idHeader[index].idStateCd, this.entries.idHeader[index].idTypeCd].join('::'));
    },
    retrieveBioKey(index) {
      return ([this.entries.bioHeader[index].lastName, this.entries.bioHeader[index].birthDt, this.entries.bioHeader[index].postalCode].join('::'));
    },
    retrievePossibleIdKeys() {
      let possibleIdKeysArray = [];
      possibleIdKeysArray = this.entries.idHeader.map(function (r) {
        return (r.idNbr + "::" + r.idStateCd + "::" + r.idTypeCd)
      })
      return possibleIdKeysArray;
    },
  },
  async beforeRouteEnter(to, _from, next) {
    let idsArray = formItem('splitById', 'checkedIds');
    try {
      let resp = await axios().get('api/person_summary/split_by_id', {
        params: { ids: JSON.stringify(idsArray) },
      })
      next(vm => {
        vm.entries = resp.data,
        vm.headers = resp.data.bioHeader
      })
    } catch(err) {
      globalError(err)
    }
  },
  components: {
    Datatable,
    HelpPopover,
    CustomCheckbox,
    CustomRadio,
    Modal,
    SplitByIdModal,
    PageHeader,
    Datepicker,
    PrintablePanel,
  },
}
</script>

<style lang="scss" scoped>

  @import '../assets/styles/bodies';
  @import '../assets/styles/breakpoints';
  .split-ids {
    margin-top: 2rem;
    label {
      @extend .body-3;
    }
  }

  .tfoot tr td {
    width: 100%;
  }

  #split-count {
    color: #7c3a74;
    cursor: pointer;
  }

  #split-count:hover {
  color: black;
  text-decoration: underline;
  cursor: pointer;
}


</style>
